import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DATA_ACCESS_ADDRESSES_FEATURE_KEY, reducers } from './reducers';
import { AddressesStoreEffects } from './effects';

@NgModule({
  imports: [
    StoreModule.forFeature(DATA_ACCESS_ADDRESSES_FEATURE_KEY, reducers),
    EffectsModule.forFeature([AddressesStoreEffects]),
  ],
})
export class AddressesStoreModule {}
